import { Hero } from "../components/home/Hero";
import { Architecture } from "../components/home/Architecture";
import { Modules, HowItWorks, AgentPreview, BrainSection, Roadmap, FinalCTA, MetricsBar } from "../components/home/HomeSections";
import { Marquee } from "../components/primitives";
import { GuardianSim } from "../components/GuardianSim";
import { SectionHeader, Reveal } from "../components/primitives";

const GuardianSection = () => (
  <section className="border-t border-white/[0.06] py-20 md:py-28" data-testid="guardian-section">
    <div className="mx-auto grid max-w-[1440px] items-start gap-12 px-5 md:px-8 lg:grid-cols-2">
      <SectionHeader
        eyebrow="Risk Engine"
        title="GUARDIAN"
        desc="AI supervision before capital moves. Every proposed action passes exposure, position, drawdown and slippage validation — an interactive simulation, not a live trading engine."
      />
      <Reveal delay={0.15}>
        <GuardianSim />
      </Reveal>
    </div>
  </section>
);

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <MetricsBar />
      <Marquee />
      <Architecture />
      <Modules />
      <HowItWorks />
      <AgentPreview />
      <GuardianSection />
      <BrainSection />
      <Roadmap />
      <FinalCTA />
    </main>
  );
}
